import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "EjecucionDetallePage",
    data() {
        let ss = new MainService();
        return {
            msg: "EjecucionDetallePage",
            ss: ss,
            ajax: {
                "url": ss.indexEjecucionDetalle(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'EjecucionConcat', name: 'Ejecucion', title: 'Ejecución' },
                { data: 'reparticion.Reparticion', name: 'Reparticion', title: 'Repartición' },
                { data: 'partida.Partida', name: 'Partida', title: 'Partida' },
                { data: 'categoria_programatica.CategoriaProgramatica', name: 'CategoriaProgramatica', title: 'Categoría Programática' },
                { data: 'Monto', name: 'Monto', title: 'Monto' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            Ejecuciones: [],
            Reparticiones: [],
            Partidas: [],
            CategoriasProgramaticas: [],
            EjecucionDetalles: [],
            EjecucionDetalle: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        getEjecucion() {
            this.ss.listEjecucion().then(
                (result) => {
                    let response = result.data;
                    this.Ejecuciones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getReparticion() {
            this.ss.listReparticion().then(
                (result) => {
                    let response = result.data;
                    this.Reparticiones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getPartida() {
            this.ss.listPartida().then(
                (result) => {
                    let response = result.data;
                    this.Partidas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        getCategoriaProgramatica() {
            this.ss.listCategoriaProgramatica().then(
                (result) => {
                    let response = result.data;
                    this.CategoriasProgramaticas = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newEjecucionDetalle() {
            this.EjecucionDetalle = {};
            this.$refs['frm-EjecucionDetalle'].show();
        },
        showEjecucionDetalle(id) {
            this.isLoading = true;
            this.ss.showEjecucionDetalle(id).then(
                (result) => {
                    let response = result.data;
                    this.EjecucionDetalle = response.data;
                    this.$refs['view-EjecucionDetalle'].show();
                    this.isLoading = false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
        },
        editEjecucionDetalle() {
            this.$refs['frm-EjecucionDetalle'].show();
            this.$refs['view-EjecucionDetalle'].hide();
        },
        cancelEjecucionDetalle() {
            if (this.EjecucionDetalle.id) {
                this.$refs['view-EjecucionDetalle'].show();
            }
            this.$refs['frm-EjecucionDetalle'].hide();
        },
        saveEjecucionDetalle() {
            this.ss.storeEjecucionDetalle(this.EjecucionDetalle).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-EjecucionDetalle'].hide();
                    this.$refs['datatable-EjecucionDetalle'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteEjecucionDetalle(id) {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        this.ss.destroyEjecucionDetalle({'id':id})
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-EjecucionDetalle'].hide();
                                this.$refs['datatable-EjecucionDetalle'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-EjecucionDetalle').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.deleteEjecucionDetalle(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            
            this.getEjecucion();
            this.getReparticion();
            this.getPartida();
            this.getCategoriaProgramatica();
        }
    }
};
